export const Logo = ({ size = 40 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        data-testid="brand-logo"
        aria-label="المفتاح الذهبي"
    >
        <rect width="48" height="48" rx="10" fill="#121824" stroke="#232F45" />
        <circle cx="19" cy="19" r="8.5" stroke="#F59E0B" strokeWidth="3.5" />
        <circle cx="19" cy="19" r="2.5" fill="#F59E0B" />
        <path d="M25 25 L38 38" stroke="#F59E0B" strokeWidth="3.5" strokeLinecap="round" />
        <path d="M32 32 L36 28" stroke="#F59E0B" strokeWidth="3.5" strokeLinecap="round" />
        <path d="M35.5 35.5 L39.5 31.5" stroke="#F59E0B" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
);
